module.exports = __webpack_public_path__ + "img/SherlockHuPhD.b2e9e120.png";